var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-editor-container"},[_c('panel-group'),_c('el-row',{attrs:{"gutter":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }